const arrayToObject = (arr, key = "id", obj = {}) => {
  if (!Array.isArray(arr) || arr.length === 0) return {};

  return arr.reduce((acc, item) => {
    if (item?.[key] != null) {
      acc[item[key]] = { ...item, ...obj };
    }
    return acc;
  }, {});
};

export default arrayToObject;